<template>
    <v-dialog persistent overlay-opacity="0.8" v-model="blocked" max-width="500">
        <v-card max-width="500">
            <v-card-title>
                <v-icon left>{{ icon_credit }}</v-icon>
                Доступ закрыт
            </v-card-title>
            <v-card-text>
                <div class="mb-3">
                    Ваш баланс <b>{{ current_client.balance }}</b>₽
                    <br>
                    На выкуп заказов надо <b>{{ need_pay }}</b>₽
                    <br><br>
                    Если вы уже оплатили, ждите подтверждения и обновляйте страницу сайта
                </div>
                <v-alert
                    :icon="icon_warn"
                    outlined
                    border="left"
                    type="warning">
                    Для работы с сайтом на вашем балансе должно быть минимум <b
                    style="white-space: nowrap">{{ blocked_balance }}₽</b>
                </v-alert>
                <div class="text-center">
                    <v-btn @click="onPayment((blocked_balance - current_client.balance).toFixed(2))"
                           class="btn mb-3" block
                           color="success">
                        Оплатить {{ (blocked_balance - (current_client.balance - need_pay)).toFixed(2) }}₽
                    </v-btn>
                    <v-btn block class="btn mb-3" color="primary" @click="onReloadPage">
                        Обновить страницу
                    </v-btn>
                    <v-btn block class="btn mb-3" color="primary" @click="showBalanceHistories">
                        Посмотреть историю баланса
                    </v-btn>
                    <v-btn block class="btn" color="primary" @click="onExit">
                        Выход
                    </v-btn>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import {mdiAlertOutline, mdiCreditCardRemove} from "@mdi/js";
import EventBus from "../../event-bus";

export default {
    name: "BlockedDialog",
    data() {
        return {
            show_dialog: true,
            icon_credit: mdiCreditCardRemove,
            icon_warn: mdiAlertOutline,
        }
    },
    computed: {
        ...mapState('clients', [
            'current_client'
        ]),
        ...mapState('shop', [
            'shop'
        ]),
        ...mapState('albums', [
            'need_pay'
        ]),
        ...mapGetters('clients', [
            'has_perm'
        ]),
        blocked_balance: {
            get() {
                return this.current_client.blocked_balance || this.shop.blocked_balance
            }
        },
        blocked: {
            get() {
                return (this.blocked_balance - this.current_client.balance > 0 && !this.has_perm('immunity_block_site')) && this.show_dialog
            }
        }
    },
    methods: {
        onReloadPage() {
            location.reload();
        },
        onPayment(value) {
            const vm = this;
            EventBus.$emit('payment_dialog', {client_id: vm.current_client.id, value: value, refund: false})
        },
        showBalanceHistories() {
            this.show_dialog = false;
        },
        onExit() {
            this.$store.dispatch('auth/logout');
        }
    },
    mounted() {
        const vm = this;
        if (vm.blocked) {
            vm.$store.dispatch('albums/getAlbums', {client_id: vm.current_client.id})
            vm.$router.push({name: 'balance_histories', params: {client_id: vm.current_client.id}}).catch(() => {})
        }
    }
}
</script>

<style scoped>

</style>